import {
	SET_CONTENTS,
	SET_CONTENT,
	CLEAR_CONTENTS,
	CLEAR_CONTENT,
	ADD_CONTENT,
	UPDATE_CONTENT,
	REMOVE_CONTENT,
} from './actionTypes';

export const content = (state = {}, action) => {
	switch (action.type) {
		case SET_CONTENT:
			return action.payload;
		case UPDATE_CONTENT:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_CONTENT:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_CONTENTS:
			return action.payload;
		case ADD_CONTENT:
			return [...state, action.payload];
		case UPDATE_CONTENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_CONTENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_CONTENTS:
			return [];
		default:
			return state;
	}
};
